// @ts-expect-error Untyped module
import DomainPattern from 'PatternValidationJS/patterns/Domain';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTextColor } from '../utils/colorUtils';
// @ts-expect-error unmigrated module
import { getCookie } from 'hub-http/helpers/cookies';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { setCookie } from '../utils/cookieUtils';
import { generateScreenshot } from '../utils/unboxingClient';
export const setCompanyDomain = createAsyncThunk('chat/setCompanyDomain', async companyDomain => {
  if (!DomainPattern.test(companyDomain)) {
    return '';
  }
  const response = await generateScreenshot(companyDomain);
  return response.screenshotUrl;
});
function generateCustomChatName(state) {
  const {
    firstName,
    lastName,
    companyName
  } = state;
  const agentName = firstName || lastName ? formatName({
    firstName,
    lastName
  }) : I18n.text('app.chat.defaultAgentName');
  return companyName ? I18n.text('app.chat.defaultDisplayName', {
    agentName,
    companyName
  }) : agentName;
}
export const initialState = {
  background: '',
  accentColor: '#00a4bd',
  textColor: '#fff',
  lightTextColor: '',
  darkTextColor: '',
  firstName: '',
  lastName: '',
  companyDomain: '',
  companyName: '',
  customChatName: '',
  customChatNameDirty: false,
  welcomeMessage: ''
};
function safeAssign(target, source) {
  Object.keys(target).forEach(key => {
    if (key in source) {
      target[key] = source[key];
    }
  });
}
const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    init: state => {
      let storedChat = null;
      try {
        storedChat = JSON.parse(decodeURIComponent(getCookie('livechat-builder', document.cookie)));
        safeAssign(state, storedChat);
      } catch (_unused) {
        // no-op
      }
      if (!storedChat) {
        state.customChatName = generateCustomChatName(state);
        state.welcomeMessage = I18n.text('app.chat.defaultWelcomeMessage');
      }
    },
    set: (state, action) => {
      safeAssign(state, action.payload);
      if ('accentColor' in action.payload && action.payload.accentColor !== undefined && action.payload.lightTextColor && action.payload.darkTextColor) {
        state.textColor = getTextColor(action.payload.accentColor, action.payload.lightTextColor, action.payload.darkTextColor);
      }
      if (('firstName' in action.payload || 'lastName' in action.payload || 'companyName' in action.payload) && !state.customChatNameDirty) {
        state.customChatName = generateCustomChatName(state);
      }
      if ('companyDomain' in action.payload) {
        state.background = '';
      }
      if ('customChatName' in action.payload) {
        state.customChatNameDirty = true;
      }

      // Todo move to middleware
      setCookie('livechat-builder', JSON.stringify(state));
    }
  },
  extraReducers: builder => {
    builder.addCase(setCompanyDomain.fulfilled, (state, action) => {
      state.background = action.payload;

      // Todo move to middleware
      setCookie('livechat-builder', JSON.stringify(state));
    });
  }
});
export const chat = chatSlice.reducer;
export const ChatActions = chatSlice.actions;